import React, { useState } from "react";

function Sector({ angle, index, onClick, mesaID, listaAsientos, reserved ,selected}) {
  const [letter, setLetter] = useState(String.fromCharCode(65 + index));

  //const [selected, setSelected] = useState(false);
  const [isLocket, setIsLocket] = useState(false);

  function handleClick() {
    //console.log("el identificador de la silla es " + mesaID + `${letter}`);

	if (!reserved) {
		onClick(mesaID + `${letter}`);
    }
  }

  const radius = 100;
  const path = `M 0 0 L ${radius * Math.cos(angle.startAngle)} ${
    radius * Math.sin(angle.startAngle)
  } A ${radius} ${radius} 0 0 1 ${radius * Math.cos(angle.endAngle)} ${
    radius * Math.sin(angle.endAngle)
  } Z`;

  return (
    <g
      onClick={handleClick}
    >
      <path d={path} fill="#fff" stroke="#000" strokeWidth="2" />

    
      {selected && (
        <path d={path} fill="#acd9b2" stroke="#acd9b2" strokeWidth="2">
          {letter}
        </path>
      )}
      {reserved && (
        <path
          d={path}
          fill=" #ffb3b3"
          stroke="#ffb3b3"
          strokeWidth="2"
			style={{cursor:"not-allowed"}}
        >
          {letter}
        </path>
      )}
      <text
        x={radius * 0.8 * Math.cos((angle.startAngle + angle.endAngle) / 2)}
        y={radius * 0.8 * Math.sin((angle.startAngle + angle.endAngle) / 2)}
        fill="#000"
        textAnchor="middle"
        alignmentBaseline="middle"
        fontSize="20"
      >
        {letter}
      </text>
    </g>
  );
}

export default Sector;
